<template>
  <div class="meeting-set-box" v-loading="meetingSetLoading">
    <div class="meeting-set-body">
      <div class="body-item">
        <div class="item-title">提醒设置</div>

        <!-- 参会人员不足提醒 -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">参会人数不足提醒:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '在会议召开后' +
                (peopleInsufficient.time || 'N') +
                '分钟，如参与会议不足' +
                (peopleInsufficient.count || 'N') +
                '人，则向代表发送该通知。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <SetSelect
              :range="120"
              :partitiontype="1"
              placeholder="请输入时间"
              suffix="分钟"
              v-model="peopleInsufficient.time"
              class="input-com-left"
              label="召开前"
            />
            <SetSelect
              :range="20"
              :partitiontype="1"
              placeholder="请输入人数"
              suffix="人"
              label="人数不足"
              type="count"
              v-model="peopleInsufficient.count"
            />
          </div>
        </div>
        <!-- 入会提醒: -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">入会提醒:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '在会议召开前' +
                (membership.time || 'N') +
                '分钟，发送会议召开提醒，向代表发送该通知。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <SetSelect
              :range="60"
              :partitiontype="5"
              label="会议前"
              placeholder="请输入次数"
              suffix="分钟"
              v-model="membership.time"
            />
          </div>
        </div>
        <!-- 参会者时间不足提醒: -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">参会者参会时间不足提醒:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '如有参会人参会时间不足' +
                (insufficientReminder.deficiencyTime || 'N') +
                '分钟，则发送该通知。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <SetSelect
              :range="60"
              partitiontype="1"
              placeholder="请输入时间"
              suffix="分钟"
              label="时间不足"
              v-model="insufficientReminder.deficiencyTime"
            />
          </div>
        </div>
      </div>
      <div class="body-item">
        <div class="item-title">数据展示设置</div>
        <!-- 医生端过往会议展示场次配置: -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">医生端过往会议展示场次配置:</div>
          </div>
          <div class="input-main">
            <el-radio-group v-model="datademonstration.sceneConfiguration">
              <el-radio label="1">过往三场记录</el-radio>
              <el-radio label="2">过往30天记录</el-radio>
              <el-radio label="3">过往365天记录</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 30天内参会超标警示配置： -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">30天内参会超标警示配置:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              :content="
                '在过去30天内参与会议超过' +
                (datademonstration.warningConfiguration || 'N') +
                '场，则将重点标志该医生。'
              "
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <InputCom
              @change="warningInput"
              placeholder="请输入次数"
              suffix="场"
              label="参会次数"
              v-model="datademonstration.warningConfiguration"
            />
          </div>
        </div>
      </div>
      <div class="body-item">
        <div class="item-title">关联配置</div>
        <!-- 对会议数据源进行选择和配置 -->
        <div class="remind-row">
          <div class="lable-title">
            <div class="title-words">对会议数据源进行选择和配置：</div>
          </div>
          <div class="input-main">
            <el-radio-group @change="relatedChange" v-model="related.config">
              <el-radio label="1">腾讯会议</el-radio>
              <el-radio label="2" disabled>其他会议</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="body-item">
        <div class="item-title">
          <div class="title-words">会议合规校验条件</div>
        </div>
        <!-- 参会人员不足提醒 -->
        <div class="remind-row amendLabelTitle">
          <div class="input-main">
            <SetSelect
              :range="60"
              :partitiontype="10"
              placeholder="请输入时间"
              suffix="分钟"
              v-model="lowestAttend.lowestTime"
              class="input-com-lowest"
              label="最低参会时长"
            />
            <div class="popover_1">
              <el-popover
                placement="top-start"
                width="324"
                trigger="click"
                :content="
                  '低于' + (lowestAttend.lowestTime || 'N') + '分钟的参会人将不作为合格参会人'
                "
              >
                <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
              </el-popover>
            </div>

            <InputCom
              @change="lowestInput"
              placeholder="请输入人数"
              suffix="人"
              label="最低参会人数"
              v-model="lowestAttend.lowestPeople"
            />
            <div class="popover_2">
              <el-popover
                placement="top-start"
                width="324"
                trigger="click"
                :content="
                  '合格参会人数少于' + (lowestAttend.lowestPeople || 'N') + '人则属于违规会议'
                "
              >
                <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="body-item">
        <div class="item-title">
          <div class="title-words">员工权限设置</div>
        </div>
        <!-- 是否允许创建会议申请 -->
        <div class="remind-row amendLabelTitle">
          <div class="lable-title">
            <div class="title-words">是否允许创建会议申请:</div>
            <el-popover
              placement="top-start"
              width="324"
              trigger="click"
              content="允许后，员工端将出现 会议申请 按钮"
            >
              <img slot="reference" :src="wenhao" class="icon-wenhao" alt="" />
            </el-popover>
          </div>
          <div class="input-main">
            <el-switch v-model="create_switch" @change="handleCreateChange"></el-switch>
          </div>
        </div>
        <!-- 会议是否需要审批 -->
        <div class="remind-row amendLabelTitle">
          <div class="lable-title">
            <div class="title-words">会议是否需要审批:</div>
          </div>
          <div class="input-main">
            <el-switch v-model="approval_switch" :disabled="!create_switch"></el-switch>
          </div>
        </div>
      </div>
      <div class="body-item encryption" v-if="false">
        <div class="item-title">加密开关</div>
        <!-- 对所有会议进行加密，非小程序注册用户不得入会： -->
        <div class="remind-row">
          <div class="lable-title encryption-switch">
            <div class="title-words">对所有会议进行加密，非小程序注册用户不得入会：</div>
          </div>
          <div class="input-main">
            <el-switch v-model="encryption"></el-switch>
          </div>
        </div>
      </div>
    </div>
    <div class="submit">
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </div>
  </div>
</template>
<script>
import InputCom from './components/inputCom';
import SetSelect from './components/setSelect';
import { GetMeetingConfig, SaveMeetingConfig } from '@/api/setUser';
export default {
  name: 'MeetingSet',
  components: {
    InputCom,
    SetSelect,
  },
  data() {
    return {
      dialogWords: '',
      wenhao:
        'https://baike-med-1256891581.file.myqcloud.com/2021058/6dc96a10-b6be-11eb-9f82-2f36b21da993_0.png',
      meetingSetLoading: false,
      dialogTitle: '',
      peopleInsufficient: {
        time: '',
        count: '',
      }, // 参会人数不足提醒
      membership: {
        time: '',
      }, // 入会提醒

      insufficientReminder: {
        deficiencyTime: '', // 时间不足
        afterConvene: '', // 召开后
      }, // 时间不足提醒

      datademonstration: {
        sceneConfiguration: '', // 场次配置
        warningConfiguration: '', // 警示配置
      }, // 数据展示

      related: {
        config: '1',
      }, // 关联配置

      lowestAttend: {
        lowestTime: '', // 最低参会时间
        lowestPeople: '', // 最低参会人数
      }, // 最低参会合规效验

      create_switch: false, // 是否允许创建会议
      approval_switch: false, // 会议是否需要审批

      encryption: false, // 加密开关
    };
  },
  mounted() {},
  created() {
    this.getMeetingConfig();
  },
  methods: {
    /**
     *获取药企下所有策略
     */
    async getMeetingConfig() {
      this.meetingSetLoading = true;
      GetMeetingConfig()
        .then((res) => {
          console.log('获取药企下所有策略', res);
          if (res) {
            this.peopleInsufficient.time = res.under_represented_time.toString(); // 参会人数不足提醒: //人数
            this.peopleInsufficient.count = res.under_represented_num.toString(); // 参会人数不足提醒:  //时间;
            this.membership.time = res.advance_remind.toString(); // 入会提醒: 会议开始前，单位分钟
            this.insufficientReminder.deficiencyTime = res.short_time_remind.toString(); // 参会者时间不足提醒
            this.datademonstration.sceneConfiguration = res.show_type.toString(); // 医生端展示过往场次数量配置类型：1:过往三场记录，2:过往30天记录，3:过往365天记录
            this.datademonstration.warningConfiguration = res.max_attendance.toString(); // 近30天内参与会议场次超标阈值
            this.related.config = res.client_type.toString(); // 关联配置
            this.lowestAttend.lowestTime = res.min_attendance_duration.toString(); // 最低参会时间
            this.lowestAttend.lowestPeople = res.min_attendance_count.toString(); // 最低参会人数
            this.create_switch = res.create_switch === 1; // 是否允许创建会议
            this.approval_switch = res.approval_switch === 1; // 会议是否需要审批
            this.$message.success('配置读取成功');
          } else {
            this.$message.warning('配置读取失败');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.warning('配置读取失败');
        });
      this.meetingSetLoading = false;
    },
    warningInput(e) {
      const reg = /^[0-9]*$/;
      if (!reg.test(e.trim())) {
        this.datademonstration.warningConfiguration = '';
      }
    },
    lowestInput(e) {
      const reg = /^[0-9]*$/;
      if (!reg.test(e.trim())) {
        this.lowestAttend.lowestPeople = '';
      }
    },
    /**
     *选择是否腾讯会议
     */
    relatedChange() {},
    /**
     *点击提交按钮
     */
    async onSubmit() {
      if (this.verifyParams()) {
        this.SaveConfiguration();
      }
    },
    /**
     *提交验证·
     */
    verifyParams() {
      if (!(this.peopleInsufficient.time && this.peopleInsufficient.count)) {
        this.dialogMethod('参会人数不足提醒');
        return false;
      }
      if (!this.insufficientReminder.deficiencyTime) {
        this.dialogMethod('参会者参会时间不足提醒');
        return false;
      }
      return true;
    },
    dialogMethod(text) {
      this.$alert(`${text}未填写完整`, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: () => {},
      });
    },
    /**
     *更改企业配置
     */
    async saveMeetingConfig() {
      this.meetingSetLoading = true;
      const params = {
        under_represented_time: this.peopleInsufficient.time, // 参会人数不足提醒: //人数
        under_represented_num: this.peopleInsufficient.count, // 参会人数不足提醒:  //时间;
        advance_remind: this.membership.time, // 入会提醒
        short_time_remind: this.insufficientReminder.deficiencyTime, // 参会者时间不足提醒
        show_type: this.datademonstration.sceneConfiguration, // 医生端展示过往场次数量配置类型：1:过往三场记录，2:过往30天记录，3:过往365天记录
        max_attendance: this.datademonstration.warningConfiguration, // 30天警示
        client_type: this.related.config, // 会议类型
        min_attendance_duration: this.lowestAttend.lowestTime, // 最低参会时间
        min_attendance_count: this.lowestAttend.lowestPeople, // 最低参会人数
        create_switch: this.create_switch ? 1 : 2,
        approval_switch: this.approval_switch ? 1 : 2,
      };
      SaveMeetingConfig(params)
        .then((res) => {
          console.log('保存药企下所有策略', res);
          if (res) {
            this.$message.success('保存成功');
          } else {
            this.$message.warning('保存失败');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.warning('保存失败');
        });
      this.meetingSetLoading = false;
    },
    SaveConfiguration() {
      this.$confirm('是否保存填写内容', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success',
      })
        .then(() => {
          this.saveMeetingConfig();
        })
        .catch(() => {});
    },
    handleCreateChange() {
      if (!this.create_switch) {
        this.approval_switch = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
